export const ADDRESS_DEFAULT_COUNTRY_CODE = {
  DE: 'DE',
};
